










































































import Vue from 'vue'
import { cloneDeep } from 'lodash'
import drawer from './drawer.vue'
import { appSettingCols, dataTypes, formTypes } from './data'
import { IotAppSettingServiceProxy } from '@/service-proxies/app-v2/iot-console.service-proxies'

const iassp = new IotAppSettingServiceProxy()
export default Vue.extend({
  props: ['app', 'gatewayCode'],
  components: { drawer },
  data() {
    return {
      dataTypes,
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      visible: false,
      loading: false,
      dataSource: [],
      form: {},
      formItems: [], // 表单项，动态生成
      submitLoading: false
    }
  },
  computed: {
    appSettingCols() {
      return appSettingCols.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    },
    drawerTitle() {
      if (this.app) {
        return this.app.name + this.$t('page_setting')
      } else {
        return ''
      }
    }
  },
  methods: {
    showDrawer() {
      this.visible = true
      this.getList()
    },
    onClose() {
      this.visible = false
    },
    async getList() {
      this.dataSource = []
      if (!this.app || !this.gatewayCode) {
        return
      }
      this.loading = true
      try {
        let { items } = await iassp.getIotAppSettingList(this.app.code, this.gatewayCode)
        this.dataSource = cloneDeep(items)
        this.dataSource.map((item, index) => item.rowKey = index)
      } catch (e) {
        console.log(e)
      }
      this.loading = false
      this.handleData()
    },
    handleData() {
      let temp = {}
      let formItems = []
      let types = Object.keys(formTypes)
      const splitStr = (val, type, dataType) => {
        let res
        if (dataType > 64) {
          res = JSON.parse(val)
        }
        if (~type.toLowerCase().indexOf('switch')) { //1,65
          for (let i in res) {
            res[i] = !!(Number(res[i]))
          }
        }
        return res
      }

      this.dataSource && this.dataSource.forEach(item => {
        item.dataType = Number(item.dataType)

        // 匹配显示的表单
        types.map(t => {
          if (formTypes[t].includes(item.dataType)) {
            formItems.push({ type: t, label: item.name, key: item.code, multi: !!(~t.indexOf('multi')) })

            if (item.currentValue) { // 赋当前值
              temp[item.code] = item.currentValue
              if (~t.indexOf('multi')) { // 类型为数组时拆解当前值，将字符串转成数组
                temp[item.code] = splitStr(item.currentValue, t, item.dataType)

              }
            } else {
              temp[item.code] = item.defaultValue // 赋默认值
              if (~t.indexOf('multi')) { // 类型为数组时拆解当前值，将字符串转成数组
                temp[item.code] = splitStr(item.defaultValue, t, item.dataType)
              }
            }
            if (t === 'switch') {
              temp[item.code] = !!(Number(temp[item.code]))
            }
          }
        })
      })
      this.form = temp
      this.formItems = formItems
    },
    // 表单里的数组转字符串
    revertArrayToStr(data) {
      let temp = cloneDeep(data)
      let keys = Object.keys(temp)
      keys.map(k => {
        if (temp[k] === true) {// switch
          temp[k] = '1'
        } else if (temp[k] === false) {
          temp[k] = '0'
        }

        if (typeof temp[k] === 'object') { // 数组
          let arr = []
          for (let i in temp[k]) {
            //multiSwitch
            if (temp[k][i] === true) {
              temp[k][i] = '1'
            } else if (temp[k][i] === false) {
              temp[k][i] = '0'
            }
            arr.push(temp[k][i])
          }
          if (arr.length === 0) {
            temp[k] = null
          } else {
            temp[k] = JSON.stringify(arr)
          }
        }
      })
      return temp
    },
    // 保存
    async saveIotAppSetting() {
      let submitData = this.revertArrayToStr(this.form)
      let params: any = {
        gatewayCode: this.gatewayCode,
        iotAppCode: this.app.code,
        settingData: submitData
      }

      this.submitLoading = true
      try {
        let res = await iassp.saveIotAppSetting(params)
        this.$message.success(this.$t('page_transport_select_save_success'))
        this.getList()
      } catch (e) {
        console.log(e)
      }
      this.submitLoading = false
    },
    remove(key, index) {
      if (this.form[key].length === 1) {
        return
      }
      let temp = cloneDeep(this.form)
      temp[key].splice(index, 1)
      this.form = cloneDeep(temp)
    },
    add(key, type) {
      let temp = cloneDeep(this.form)
      if(type==='multiSwitch') {
        temp[key].push(true)
      } else {
        temp[key].push('')
      }

      this.form = cloneDeep(temp)
    },
    changeFormItemValue(key, index, value) {
      let temp = cloneDeep(this.form)
      temp[key][index] = value
      this.form = cloneDeep(temp)
    },
    refresh() {
      this.getList()
    }
  }
})
